import BubbleCommon, { TipsMapType } from '@op/components/BubbleCommon';
import React from 'react';

export default function CommonText({
  title,
  list,
  description,
}: {
  title: string;
  list: Array<string | { text: string; tipsMap: TipsMapType }>;
  description: string;
}) {
  return (
    <div className="dbo-monitoring-common-text">
      <h2 className="dbo-monitoring-scope-subtitle">{title}</h2>
      {description && <p>{description}</p>}
      {list && (
        <ul className="dbo-monitoring-scope-ul">
          {list.map((item) => {
            const isString = typeof item === 'string';
            const { text, ...bubbleProps } = isString
              ? { text: item, tipsMap: null, showIcon: false }
              : item;

            return (
              <li key={text}>
                {text} <BubbleCommon {...bubbleProps}></BubbleCommon>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
